import { Dictionary, remove, uniqBy } from 'lodash';
import { Room } from '../../libs/gs-component-hotel-planner/contexts/TransientRooms';
import axios from 'axios';
import { get } from 'js-cookie';
import moment from 'moment';

interface WeddingLocation {
  city: string;
  state: string;
}

export interface EngineHotel {
  id: string;
  name: string;
  address: string[];
  city: string;
  state: string;
  country: string;
  postalCode: string;
  description: string;
  profileUrl: string;
  imagePath: string;
}

interface GetEngineHotelsResponse {
  data: EngineHotel[];
}

export const parseWeddingLocationString = (weddingLocation: string): WeddingLocation => {
  const weddingLocationChunks = weddingLocation.split(',');

  const weddingLocationCity = weddingLocationChunks[0];

  let weddingLocationState = ' ';
  if (weddingLocationChunks.length > 1) {
    weddingLocationState = weddingLocationChunks[1].trim();
  }

  return {
    city: weddingLocationCity,
    state: weddingLocationState,
  };
};

export const buildGetHotelsUrl = (weddingLocation: WeddingLocation): string => {
  const TRAVEL_ARRANGEMENT_ENDPOINT = process.env.REACT_APP_TRAVEL_ARRANGEMENT_API_HOST;
  return `${TRAVEL_ARRANGEMENT_ENDPOINT}/hotels/engine?city=${weddingLocation.city}&state=${weddingLocation.state}&radius=15`;
};

export const buildEngineHotelUrl = (profileUrl: string, weddingDate: string): string => {
  const inDate = moment(weddingDate)
    .subtract(1, 'days')
    .format('YYYY-MM-DD');
  const outDate = moment(weddingDate)
    .add(1, 'days')
    .format('YYYY-MM-DD');
  const redirectUrl = `${profileUrl}?checkIn=${inDate}&checkOut=${outDate}&roomCount=1&guestCount=2`;

  const ENGINE_JOIN_URL = process.env.REACT_APP_ENGINE_JOIN_URL;

  return `${ENGINE_JOIN_URL}?redirect_url=${encodeURIComponent(redirectUrl)}`;
};

export const mapEngineHotelToRoom = (engineHotel: EngineHotel, weddingDate: string): Room => {
  return {
    propertyId: engineHotel.id,
    address1: engineHotel.address.join(', '),
    city: engineHotel.city,
    stateCode: engineHotel.state,
    country: engineHotel.country,
    description: engineHotel.description,
    imagePath: engineHotel.imagePath,
    price: 0,
    profileUrl: buildEngineHotelUrl(engineHotel.profileUrl, weddingDate),
    propertyName: engineHotel.name,
    provider: 'engine',
  };
};

export const getHotelsWithEngine = async (
  excludeLookup: Dictionary<string>,
  weddingDate: string,
  weddingLocationString: string
): Promise<Room[]> => {
  if (weddingDate && weddingLocationString) {
    try {
      const weddingLocation = parseWeddingLocationString(weddingLocationString);
      const response: GetEngineHotelsResponse = await axios.get(buildGetHotelsUrl(weddingLocation), {
        headers: {
          token: get('xo-session-token') as string,
        },
      });
      const hotels = response.data;

      const rooms = remove(
        hotels.map(engineHotel => mapEngineHotelToRoom(engineHotel, weddingDate)),
        (room: Room) => !excludeLookup[room.propertyId]
      );

      return uniqBy(rooms, room => room.propertyId);
    } catch (e) {
      console.error('Error fetching Engine Hotels', e);
      return [];
    }
  }

  return [];
};
